import Footer from './components/Footer/Footer.jsx';
import Home from './pages/Home.jsx';
import Header from './components/Header/Header.jsx';
import Store from './pages/Store.jsx';
import Allstore from "./pages/allStore.jsx";
import About from './pages/About.jsx';
import Cars from './pages/Cars.jsx';
import Cart from './pages/Cart.jsx';
import Wishlist from './pages/Wishlist.js';
import Oferta from "./pages/Oferta.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import SearchItem from "./components/Search/SearchItem.jsx";
import ProductDetail from './components/Product/ProductDetail.jsx';
import {Switch, Route} from "react-router-dom"
import React, {useContext} from 'react'
import {Helmet} from "react-helmet";
import {StateContext} from "./context/GlobalState";
import {GetText} from "./context/text";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'remixicon/fonts/remixicon.css';
import './css/style.css';
import './css/header.css';
import './css/footer.css';
import './css/product.css';
import './css/pagination.css';
import './css/cartitem.css';
import './css/favoriteitem.css';



function App() {
    let {lang} = useContext(StateContext)
    let text = GetText();

    return (
        <div>
            <Helmet htmlAttributes={{ lang : lang }}>
                <title>Zapauto - {text.Header.desc}</title>
                <meta name="description" content={text.Header.name + ' - zapauto.com.ua'} />
                <meta name="keywords"
                      content={text.Header.name + ', ' + text.Header.desc + ', zapauto.com.ua'}/>

            </Helmet>
            <Header />
               <Switch>
                    <Route exact path="/">
                        <Home />
                    </Route>

                   <Route path="/catalog/:pageURL">
                       <Store />
                   </Route>


                   <Route exact path="/catalog">
                       <Store />
                   </Route>

                   <Route path="/allcatalog/:pageURL">
                       <Allstore />
                   </Route>

                   <Route exact path="/allcatalog">
                       <Allstore />
                   </Route>


                   <Route path="/about">
                       <About />
                   </Route>

                   <Route path="/cars">
                       <Cars />
                   </Route>


                   <Route path="/cart">
                       <Cart />
                   </Route>

                   <Route path="/wishlist">
                       <Wishlist />
                   </Route>


                   <Route path="/search-:searchRequest">
                       <SearchItem />
                   </Route>

                   <Route path="/product/:productPartNumber">
                       <ProductDetail />
                   </Route>

                   <Route path="/oferta">
                       <Oferta />
                   </Route>

                   <Route path="/privacy-policy">
                       <PrivacyPolicy />
                   </Route>


               </Switch>

                <Footer/>
        </div>
    );
}

export default App;
